import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, Fragment, useEffect, useContext } from 'react';
import { useChartData } from '../context/ChartContext';
import NoData from './NoData';
import { spinnerContext } from './SpinnerContext';
function Spinner({ isLoading = true, emptyText = undefined }) {
    const { data } = useChartData();
    const [checkEmpty, startCheckEmpty] = useState(false);
    useEffect(() => {
        let timeout = null;
        if (!isLoading) {
            timeout = setTimeout(() => {
                startCheckEmpty(true);
            }, 500);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [isLoading]);
    const getSpinner = useContext(spinnerContext);
    return (_jsxs(Fragment, { children: [isLoading && getSpinner(), checkEmpty && !isLoading && (_jsx(NoData, { isEmpty: data && data.length === 0, emptyText: emptyText }))] }));
}
export default Spinner;
